export default __webpack_public_path__ + "static/media/chat7.37d1ab8a.jpg";